// extracted by mini-css-extract-plugin
module.exports = {"label":"AdLabel_label__h8cxL"};